import { config as loadEnvFile } from 'dotenv';
import { existsSync } from 'fs';
import { dirname, resolve } from 'path';
import { ConfigDataType } from './config.interface';

const ENV_FILE_NAME = '.env.local';

const loadLocalEnv = () => {
  for (const startDir of [process.cwd(), __dirname]) {
    let currentDir = startDir;
    while (currentDir) {
      const candidate = resolve(currentDir, ENV_FILE_NAME);
      if (existsSync(candidate)) {
        loadEnvFile({ path: candidate, override: true });
        return;
      }
      const parentDir = dirname(currentDir);
      if (parentDir === currentDir) break;
      currentDir = parentDir;
    }
  }
};

loadLocalEnv();

export const DEFAULT_CONFIG: ConfigDataType = {
  env: 'development',
  port: 2003,
  selfHost: "http://analytics23.sepl.local",
  logLevel: 'info',
  maxPayloadSize: '1000mb',
  responseTimeOut: 600,
  staticFilesFolder: 'files',
  database: {
    type: process.env.APP_DB_TYPE || 'mysql',
    host: process.env.APP_DB_HOST,
    port: Number(process.env.APP_DB_PORT) || 3306,
    username: process.env.APP_DB_USER,
    password: process.env.APP_DB_PASS,
    dbName: process.env.APP_DB_DBNAME,
  },
  rateLimiting: {
    ttl: 60,
    limit: 10,
    maxLoginAttempts: 3
  },
  appSepcific: {
    palletRollCapacity: 20
  },
  jwtConfig: {
    jwtSecret: 'rebats',
    jwtExpiryTime: '300s',   //seconds(15 mins)     
    refreshSecret: 'rebats_refresh',
    refreshExpiryTime: '7d',//days(one week)
    jwtByCookieOrHeader: 'cookie'
  },
  dbNames: {
    boip: "",
    ums: "",
  }
};
